<template>
  <el-dialog title="Configurar E-mail de Aniversário do Cliente" :visible.sync="isVisible" @open="open" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="35%">
    <el-form size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-row>
        <el-col>
          <el-form-item label="Corpo (Até 100 Caracteres)">
            <el-input v-model="form.corpo" resize="none" maxlength="100" type="textarea" style="margin-top: 5px" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-link :disabled="isDisabledLinkImagemProprietario" type="warning" @click="handleClickLinkImagemProprietario">
            <i class="el-icon-picture" />
            Imagem para o Proprietário
          </el-link>

          <el-button :disabled="isDisabledButtonAlterarImagemProprietario" @click="handleClickButtonAlterarImagemProprietario" type="text" style="margin-left: 10px">
            <i class="el-icon-edit" />
            Alterar
          </el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top: 5px">
        <el-col>
          <el-link :disabled="isDisabledLinkImagemLocatario" type="warning" @click="handleClickLinkImagemLocatario">
            <i class="el-icon-picture" />
            Imagem para o Locatário
          </el-link>

          <el-button :disabled="isDisabledButtonAlterarImagemLocatario" @click="handleClickButtonAlterarImagemLocatario" type="text" style="margin-left: 10px">
            <i class="el-icon-edit" />
            Alterar
          </el-button>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button type="success" size="small" @click="handleClickButtonConcluir" round class="btn-box-shadow">
        <i class="el-icon-check" />
        Concluir
      </el-button>
    </span>

    <dialog-upload-imagem-proprietario :isVisible="isVisibleDialogUploadImagemProprietario" @upload="uploadImagemProprietario" @close="fecharDialogUploadImagemProprietario" />
    <dialog-upload-imagem-locatario :isVisible="isVisibleDialogUploadImagemLocatario" @upload="uploadImagemLocatario" @close="fecharDialogUploadImagemLocatario" />
  </el-dialog>
</template>

<script>
import DialogUploadImagemProprietario from './UploadImagemEmailAniversarioProprietarioDialog';
import DialogUploadImagemLocatario from './UploadImagemEmailAniversarioLocatarioDialog';
import { mapActions, mapState } from 'vuex';
import axios from 'axios';
import URLS from '../../../util/urls';

const baseForm = {
  corpo: '',
};
const baseUrlImagemProprietario = '';
const baseUrlImagemLocatario = '';

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    DialogUploadImagemProprietario,
    DialogUploadImagemLocatario,
  },

  data() {
    return {
      form: { ...baseForm },

      urlImagemProprietario: baseUrlImagemProprietario,
      urlImagemLocatario: baseUrlImagemLocatario,

      isDisabledButtonAlterarImagemProprietario: false,
      isDisabledButtonAlterarImagemLocatario: false,

      isVisibleDialogUploadImagemProprietario: false,
      isVisibleDialogUploadImagemLocatario: false,
    };
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    hasImagemProprietario() {
      return this.urlImagemProprietario !== baseUrlImagemProprietario;
    },
    hasImagemLocatario() {
      return this.urlImagemLocatario !== baseUrlImagemLocatario;
    },

    isDisabledLinkImagemProprietario() {
      return !this.hasImagemProprietario;
    },
    isDisabledLinkImagemLocatario() {
      return !this.hasImagemLocatario;
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),
    ...mapActions('loginStore', [
      'relogar',
    ]),

    open() {
      this.reset();
      this.recuperarParametros();
    },

    recuperarParametros() {
      this.showLoading();

      this.recuperar()
        .then(this.handleResultRecuperar)
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    handleResultRecuperar(result) {
      switch (result.status) {
        case 'SUCESSO':
          this.setForm(result.item);
          this.setUrlImagens(result.item);
          break;

        case 'FALHA':
          this.disableButtonAlterarImagemProprietario();
          this.disableButtonAlterarImagemLocatario();
          break;
      
        case 'ERRO':
          this.$message.error("Não foi possível recuperar os parâmetros");
          break;
      }
    },

    recuperar() {
      return axios.post(URLS.IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_ANIVERSARIO)
        .then(response => {
          switch (response.data.status) {
            case 'SESSAO_EXPIRADA':
              return this.relogar().then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.recuperar();
                }
              });
          
            default:
              return response.data;
          }
        })
        .catch(error => {
          throw error;
        });
    },

    setForm(parametros) {
      this.form.corpo = parametros.corpo;
    },

    setUrlImagens(parametros) {
      this.setUrlImagemProprietario(parametros.imagemProprietario);
      this.setUrlImagemLocatario(parametros.imagemLocatario);
    },

    setUrlImagemProprietario(url) {
      if(url !== null) this.urlImagemProprietario = url;
    },
    setUrlImagemLocatario(url) {
      if(url !== null) this.urlImagemLocatario = url;
    },

    handleClickLinkImagemProprietario() {
      this.openNewTab(this.urlImagemProprietario);
    },
    handleClickLinkImagemLocatario() {
      this.openNewTab(this.urlImagemLocatario);
    },

    handleClickButtonConcluir() {
      this.gravar();
    },

    gravar() {
      const payload = {
        corpo: this.form.corpo.trim(),
      };
      this.showLoading();

      this.gravarParametros(payload)
        .then(this.handleResultGravar)
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    handleResultGravar(result) {
      switch (result.status) {
        case 'SUCESSO':
          this.$message.success(result.mensagem);
          this.setForm(result.item);
          this.enableButtonAlterarImagemProprietario();
          this.enableButtonAlterarImagemLocatario();
          break;
      
        case 'ERRO':
          this.$message.error(result.mensagem);
          break;
      }
    },

    gravarParametros(payload) {
      return axios.post(URLS.IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_ANIVERSARIO, payload)
        .then(response => {
          switch (response.data.status) {
            case 'SESSAO_EXPIRADA':
              return this.relogar().then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.gravarParametros(payload);
                }
              });
          
            default:
              return response.data;
          }
        })
        .catch(error => {
          throw error;
        });
    },

    uploadImagemProprietario(urlImagem) {
      this.setUrlImagemProprietario(urlImagem);
      this.fecharDialogUploadImagemProprietario();
    },
    uploadImagemLocatario(urlImagem) {
      this.setUrlImagemLocatario(urlImagem);
      this.fecharDialogUploadImagemLocatario();
    },

    handleClickButtonAlterarImagemProprietario() {
      this.exibirDialogUploadImagemProprietario();
    },
    handleClickButtonAlterarImagemLocatario() {
      this.exibirDialogUploadImagemLocatario();
    },

    exibirDialogUploadImagemProprietario() {
      this.isVisibleDialogUploadImagemProprietario = true;
    },
    fecharDialogUploadImagemProprietario() {
      this.isVisibleDialogUploadImagemProprietario = false;
    },

    exibirDialogUploadImagemLocatario() {
      this.isVisibleDialogUploadImagemLocatario = true;
    },
    fecharDialogUploadImagemLocatario() {
      this.isVisibleDialogUploadImagemLocatario = false;
    },

    enableButtonAlterarImagemProprietario() {
      this.isDisabledButtonAlterarImagemProprietario = false;
    },
    disableButtonAlterarImagemProprietario() {
      this.isDisabledButtonAlterarImagemProprietario = true;
    },

    enableButtonAlterarImagemLocatario() {
      this.isDisabledButtonAlterarImagemLocatario = false;
    },
    disableButtonAlterarImagemLocatario() {
      this.isDisabledButtonAlterarImagemLocatario = true;
    },

    openNewTab(url) {
      window.open(url, '_blank');
    },

    fechar() {
      this.$emit('close');
    },

    reset() {
      this.form = { ...baseForm };

      this.urlImagemProprietario = baseUrlImagemProprietario;
      this.urlImagemLocatario = baseUrlImagemLocatario;

      this.isDisabledButtonAlterarImagemProprietario = false;
      this.isDisabledButtonAlterarImagemLocatario = false;
    },
  },
}
</script>